import styled, { css } from 'styled-components';
import { darken } from 'polished';

import theme from '@styles/theme';
import { getBadgeColor } from '@utils/common';

type FontType = {
    $fontSize?: number;
    $fontColor?: string;
    $margin?: string;
};

type FlexBoxType = {
    $position?: string;
    $width?: string;
    $height?: string;
    $flex?: number;
    $flexDirection?: string;
    $alignItems?: string;
    $justifyContent?: string;
    $flexWrap?: string;
    $gap?: number;
    $margin?: string;
    $padding?: string;
    $border?: string;
    $fontColor?: string;
    $fontSize?: number;
};

export type BadgeColor =
    | 'gray'
    | 'darkGray'
    | 'green'
    | 'blue'
    | 'yellow'
    | 'brightYellow'
    | 'red'
    | 'orange'
    | 'purple';

type BadgeProps = {
    $status: BadgeColor;
};
export const Wrapper = styled.main<{ $minHeight?: string }>`
    margin: 0 auto;
    padding-bottom: 200px;
    max-width: 955px;
    height: 100%;
    min-height: ${({ $minHeight }) =>
        $minHeight
            ? $minHeight
            : 'calc(100vh - 80px - 180px)'}; //헤더, 푸터 높이
`;

export const BoldFont = styled.div<FontType>`
    font-family: PretendardBold, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 14)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const SemiBoldFont = styled.h3<FontType>`
    font-family: PretendardSemiBold, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 14)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const MediumFont = styled.div<FontType>`
    font-family: PretendardMedium, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 14)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const RegularFont = styled.div<FontType>`
    font-family: PretendardRegular, sans-serif;
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 14)}px;
    color: ${({ $fontColor, theme }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;

export const FlexBox = styled.div<FlexBoxType>`
    display: flex;
    flex: ${({ $flex }) => ($flex ? $flex : 1)};
    flex-direction: ${({ $flexDirection }) =>
        $flexDirection ? $flexDirection : 'row'};
    align-items: ${({ $alignItems }) => ($alignItems ? $alignItems : 'center')};
    justify-content: ${({ $justifyContent }) =>
        $justifyContent ? $justifyContent : 'flex-start'};
    flex-wrap: ${({ $flexWrap }) => ($flexWrap ? $flexWrap : 'unset')};
    gap: ${({ $gap }) => ($gap ? $gap : 0)}px;
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    padding: ${({ $padding }) => ($padding ? $padding : 0)};
    width: ${({ $width }) => ($width ? $width : '100%')};
    height: ${({ $height }) => ($height ? $height : 'auto')};
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 14)}px;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};

    ${({ $position }) =>
        $position &&
        css`
            position: ${$position};
        `}
`;

// export const Contents = styled.div<{ $margin?: string }>`
//     flex: 1;
//     margin: ${({ $margin }) => ($margin ? $margin : 0)};
// `;
// export const FilterBox = styled.div<{ $margin?: string }>`
//     display: flex;
//     gap: 20px;
//     margin: ${({ $margin }) => ($margin ? $margin : '0 0 20px')};
//     line-height: 1.5;
//     select {
//         font-family: PretendardRegular, sans-serif;
//     }
//     input {
//         font-size: 14px;
//         font-family: PretendardRegular, sans-serif;
//     }
// `;
export const Line = styled.div<{ $margin?: string }>`
    width: 100%;
    height: 1px;
    margin: ${({ $margin }) => ($margin ? $margin : '32px 0')};
    background-color: ${theme.colors.ultraLightGrayBorder};
`;
export const Description = styled(RegularFont)<{
    $margin?: string;
    $width?: string;
    $fontColor?: string;
    $fontSize?: number;
}>`
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 12)}px;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.deepGrayFontColor};
    margin: ${({ $margin }) => ($margin ? $margin : '8px 0 0')};
    max-width: ${({ $width }) => ($width ? $width : 'auto')};
    white-space: normal;
    word-break: keep-all;
`;
export const Underline = styled.span<{ $fontColor?: string }>`
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.deepGrayFontColor};
    border-bottom: ${({ $fontColor }) =>
            $fontColor ? $fontColor : theme.colors.deepGrayFontColor}
        1px solid;
    cursor: pointer;
`;

export const Badge = styled.span<BadgeProps>`
    padding: 3px 10px;
    font-size: 12px;
    line-height: 22px;
    color: ${({ $status }) => getBadgeColor($status)[0]};
    background-color: ${({ $status }) => getBadgeColor($status)[1]};
    border-radius: 4px;
    &:not(:first-of-type) {
        margin-left: 8px;
    }
`;
// export const Section = styled.section<{
//     $padding?: string;
//     $maxWidth?: number;
// }>`
//     display: flex;
//     padding: ${({ $padding }) => ($padding ? $padding : 0)};
//     width: 100%;
//     max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'auto')};
//     border-top: ${theme.colors.ultraLightGrayBorder} 1px solid;
// `;

// export const ButtonWrapper = styled.div`
//     display: flex;
//     justify-content: end;
//     gap: 8px;
//     margin-top: 32px;
// `;

export const TextButton = styled.button<{
    $margin?: string;
    $fontFamily?: string;
    $fontColor?: string;
    $fontSize?: number;
}>`
    margin: ${({ $margin }) => ($margin ? $margin : '0px')};
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 14)}px;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.deepGrayFontColor};
    font-family: ${({ $fontFamily }) =>
        $fontFamily ? $fontFamily : 'PretendardMedium'};
    transition: all 0.25s;
    &:hover {
        color: ${({ $fontColor }) =>
            $fontColor
                ? darken(0.1, $fontColor)
                : darken(0.1, theme.colors.deepGrayFontColor)};
    }
`;

export const Image = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const SubText = styled.span<{
    $margin?: string;
    $fontFamily?: string;
    $fontColor?: string;
    $fontSize?: number;
}>`
    margin: ${({ $margin }) => ($margin ? $margin : '0px')};
    font-size: ${({ $fontSize }) => ($fontSize ? $fontSize : 15)}px;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    font-family: ${({ $fontFamily }) =>
        $fontFamily ? $fontFamily : 'inherit'};
`;
export const ColorPalette = styled.span<{
    $bgColor?: string;
    $margin?: string;
    $width?: number;
    $height?: number;
}>`
    display: inline-block;
    margin: ${({ $margin }) => ($margin ? $margin : '0px')};
    width: ${({ $width }) => ($width ? $width : 20)}px;
    height: ${({ $height }) => ($height ? $height : 20)}px;
    background-color: ${({ $bgColor }) =>
        $bgColor ? $bgColor : theme.colors.whiteColor};
    vertical-align: middle;
`;

export const EditorContents = styled.div<{ $maxHeight?: string }>`
    width: 100%;
    /* max-width: 955px; */
    white-space: pre-wrap;
    word-break: break-word;
    ${({ $maxHeight }) =>
        $maxHeight &&
        css`
            max-height: ${$maxHeight};
            overflow-y: auto;
        `}
    & * {
        line-height: 24px;
        white-space: pre-wrap;
        word-break: break-word;
    }

    & img {
        max-width: 688px;
    }

    & p {
        width: 100%;
        word-break: break-all;
        margin: 4px 0;
    }

    li {
        margin: 4px 0;
    }

    ol,
    ul {
        padding-left: 1.5em;
        margin: 6px 0;
    }

    ol li {
        list-style: decimal;
        margin-left: 1.5em;
    }

    ul li {
        list-style: disc;
        margin-left: 1.5em;
    }

    h1 {
        font-size: 32px !important;
        font-weight: bold !important;
        margin-bottom: 6px;
    }

    h2 {
        font-size: 24px !important;
        font-weight: bold !important;
        margin-bottom: 6px;
    }

    h3 {
        font-size: 19px !important;
        font-weight: bold !important;
        margin-bottom: 4px;
    }

    h4 {
        font-size: 16px !important;
        font-weight: bold !important;
        margin-bottom: 2px;
    }

    h5 {
        font-size: 12px !important;
        font-weight: bold !important;
        margin-bottom: 2px;
    }

    em {
        font-style: italic !important;
    }

    b,
    strong {
        font-weight: bold !important;
    }

    // React Quill Style
    // font family
    // AppleSDGothicNeo
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-label[data-value='AppleSDGothicNeo']::before,
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-item[data-value='AppleSDGothicNeo']::before {
        content: 'AppleSDGothicNeo';
        font-family: AppleSDGothicNeoMedium, sans-serif !important;
    }

    .ql-font-AppleSDGothicNeo {
        font-family: AppleSDGothicNeoMedium, sans-serif !important;
    }

    // Nanum Gothic
    span.ql-font-NanumGothic,
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-label[data-value='NanumGothic']::before,
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-item[data-value='NanumGothic']::before {
        content: 'NanumGothic';
        font-family: 'Nanum Gothic', sans-serif !important;
    }

    .ql-font-AppleSDGothicNeo {
        font-family: AppleSDGothicNeoMedium, sans-serif !important;
    }

    // pretendard
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-label[data-value='pretendard']::before,
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-item[data-value='pretendard']::before {
        content: 'pretendard';
        font-family: PretendardMedium, sans-serif !important;
    }

    .ql-font-pretendard {
        font-family: PretendardMedium, sans-serif !important;
    }

    // sans-serif
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-label[data-value='sans-serif']::before,
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-item[data-value='sans-serif']::before {
        content: 'sans-serif';
        font-family: sans-serif !important;
    }

    .ql-font-sans-serif {
        font-family: sans-serif !important;
    }

    // monospace
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-label[data-value='monospace']::before,
    .ql-snow
        .ql-picker.ql-font
        .ql-picker-item[data-value='monospace']::before {
        content: 'monospace';
        font-family: monospace !important;
    }

    .ql-font-monospace {
        font-family: monospace !important;
    }

    // font size
    .ql-size-12px,
    .ql-size span[data-value='12px']::before {
        font-size: 12px !important;
    }

    .ql-size-14px,
    .ql-size span[data-value='14px']::before {
        font-size: 14px !important;
    }

    .ql-size-15px,
    .ql-size span[data-value='15px']::before {
        font-size: 15px !important;
    }

    .ql-size-16px,
    .ql-size span[data-value='16px']::before {
        font-size: 16px !important;
    }

    .ql-size-18px,
    .ql-size span[data-value='18px']::before {
        font-size: 18px !important;
    }

    .ql-size-20px,
    .ql-size span[data-value='20px']::before {
        font-size: 20px !important;
    }

    .ql-size-22px,
    .ql-size span[data-value='22px']::before {
        font-size: 22px !important;
    }

    .ql-size-24px,
    .ql-size span[data-value='24px']::before {
        font-size: 24px !important;
    }

    .ql-size-26px,
    .ql-size span[data-value='26px']::before {
        font-size: 26px !important;
    }

    .ql-size-28px,
    .ql-size span[data-value='28px']::before {
        font-size: 28px !important;
    }

    .ql-size-30px,
    .ql-size span[data-value='30px']::before {
        font-size: 30px !important;
    }

    .ql-size-32px,
    .ql-size span[data-value='32px']::before {
        font-size: 32px !important;
    }

    // Bold
    .ql-editor strong {
        font-weight: bold !important;
    }

    .ql-editor em {
        font-style: italic !important;
    }

    .ql-align-right {
        text-align: right !important;
    }

    .ql-align-center {
        text-align: center !important;
    }

    .ql-indent-1:not(.ql-direction-rtl) {
        padding-left: 3em !important;
    }

    .ql-indent-2:not(.ql-direction-rtl) {
        padding-left: 6em !important;
    }

    .ql-indent-3:not(.ql-direction-rtl) {
        padding-left: 9em !important;
    }

    .ql-indent-4:not(.ql-direction-rtl) {
        padding-left: 12em !important;
    }

    .ql-indent-5:not(.ql-direction-rtl) {
        padding-left: 15em !important;
    }
`;
